export default "__VITE_ASSET__8tp1y$Iw__"